<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
      <v-flex>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Server</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(mailsender, index) in mailsenders"
                :key="index"
              >
                <td>{{ mailsender.name }}</td>
                <td>{{ mailsender.host }}</td>
                <td @click="remove(mailsender)">
                  <v-icon>mdi-delete</v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>

    </v-layout>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            dark
            v-on="on"
          >Sender hinzufügen</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Sender hinzufügen</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    label="Name*"
                    v-model="sender.name"
                    required
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    label="Host"
                    v-model="sender.host"
                    required
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    label="Benutzername"
                    v-model="sender.username"
                    required
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    label="Passwort"
                    v-model="sender.password"
                    required
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    label="Port"
                    v-model="sender.port"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="close()"
            >Schließen</v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="save()"
            >Speichern</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Mails',

  data: () => ({
    mailsenders: [],
    dialog: false,
    sender: {
      name: '',
      host: '',
      username: '',
      passwort: '',
      port: '587',
      key: 'mailsender'
    }
  }),

  created () {
    this.initSender()
  },
  methods: {
    getSenders () {
      this.$http.get('/api/settings/mail/senders').then((response) => {
        this.mailsenders = response.data
      })
    },
    initSender () {
      this.getSenders()
      this.sender = {
        name: '',
        host: '',
        username: '',
        passwort: '',
        port: '587',
        key: 'mailsender'
      }
    },
    save () {
      this.$http.post('/api/settings/mail/senders', this.sender).then(() => {
        this.close()
      })
    },
    remove (sender) {
      this.$http.delete('/api/settings/mail/senders', { data: sender }).then(() => {
        this.close()
      })
    },
    close () {
      this.dialog = false
      this.initSender()
    }
  }

};
</script>
